module.exports = __webpack_public_path__ + "img/main2.28ae0afa.png";